import { SeasonCalendarMulti } from './components/multiple';
import { SeasonCalendarSingle } from './components/single';
import { SeasonCalendarItem } from './parts/item';

export const SeasonCalendar = Object.assign(SeasonCalendarSingle, {
  Multi: SeasonCalendarMulti,
  Item: SeasonCalendarItem
});
